import type { TourDefinition } from '../../../models/tour.interfaces';
import type { TourModule } from '../../../models/onboarding.constants';
import { employeesTour } from './employees.tour';
import { servicesTour } from './services.tour';
import { productsTour } from './products.tour';
import { customersTour } from './customers.tour';
import { reservationsTour } from './reservations.tour';
import { posTour } from './pos.tour';

export const tourDefinitions: Record<TourModule, TourDefinition> = {
  employees: employeesTour,
  services: servicesTour,
  products: productsTour,
  customers: customersTour,
  reservations: reservationsTour,
  pos: posTour,
};
